import { render, staticRenderFns } from "./TransferKey.vue?vue&type=template&id=8a7809c6&scoped=true&"
import script from "./TransferKey.vue?vue&type=script&lang=ts&"
export * from "./TransferKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7809c6",
  null
  
)

export default component.exports